<template>
  <c-body v-show="dataLoaded">
    <div class="l-container">
        <c-row >
            <c-col md>
                <c-panel>
                  <table class="table table--bordered table--striped">
                  <thead>
                    <tr data-label="Title">
                      <th rowspan="2">Client</th>
                      <th colspan="2" class="u-text-center">Last month</th>
                      <th colspan="2" class="u-text-center">Current month</th>
                    </tr>
                    <tr data-label="Title">
                      <th class="u-text-center">Succeeded</th>
                      <th class="u-text-center">Total</th>
                      <th class="u-text-center">Succeeded</th>
                      <th class="u-text-center">Total</th>
                    </tr>
                  </thead>
                  <tr v-for="u in data" v-bind:key="u.client_id">
                    <td><a href="#" @click.prevent="onSelectClient(u.client_id)">{{u.client_name}}</a><div v-if="u.clientStatus !== 'ACTIVE'" class="icon-warning2 u-fr u-color-danger"></div> </td>
                    <td class="u-text-center">{{u.prev_succeeded}}</td>
                    <td class="u-text-center">{{u.prev_total}}</td>
                    <td class="u-text-center">{{u.succeeded}}</td>
                    <td class="u-text-center">{{u.total}}</td>
                  </tr>
                  </table>
                </c-panel>
            </c-col>
        </c-row>
    </div>
  </c-body>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import admin from '../services/admin.service'

export default {
  name: 'AdminHome',

  computed: {
    ...mapState('auth', ['clientCode', 'clientId'])
  },

  data () {
    return {
      data: [],
      dataLoaded: false
    }
  },

  created () {
    this.refreshData()
  },

  methods: {
    ...mapMutations({
      setCurrentClient: 'auth/setCurrentClient',
      setRequestProperties: 'client/setRequestProperties'
    }),

    refreshData () {
      this.getData()
    },

    getData () {
      admin.getClients(null, null).then((response) => {
        this.handleData(response.data)
      }).catch((reason) => {
        console.error('Could not get data')
        console.error(reason)
      })
    },

    handleData (data) {
      this.data = data
      this.dataLoaded = true
    },

    onSelectClient (clientId) {
      for (var i = 0; i < this.data.length; i++) {
        if (this.data[i].client_id === clientId) {
          this.setCurrentClient(this.data[i])
          this.setRequestProperties(null)
          this.$router.push({name: 'UserDocuments'})
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdminHome.vue